import {UsageEvent} from '../types';

// FNP-536: the "did this event bill?" signal. A row is BILLABLE only when both flags are
// clear (the FNP-215 invariant: customerMeterKey is stamped, the aggregator picks it up).
// Otherwise it is stuck at the front of the pipeline:
//   unresolvedCustomer -> who-pays unknown (awaiting R1 backfill)
//   unmetered          -> meterCode not in the catalog
// One derivation, used by the badge AND the Status sort, so what is sorted is what the
// cell shows (FNP-1883).
export type BillableStatus = 'BILLABLE' | 'UNMETERED' | 'UNRESOLVED_CUSTOMER';

type StatusFlags = Pick<UsageEvent, 'unresolvedCustomer' | 'unmetered'>;

export const billableStatus = (record: StatusFlags): BillableStatus => {
    if (record.unresolvedCustomer) {
        return 'UNRESOLVED_CUSTOMER';
    }
    if (record.unmetered) {
        return 'UNMETERED';
    }
    return 'BILLABLE';
};

// Sort rank by severity, not by the translated label, so the order does not change with
// the locale: billable first ascending, unresolved first descending.
const RANK: Record<BillableStatus, number> = {
    BILLABLE: 0,
    UNMETERED: 1,
    UNRESOLVED_CUSTOMER: 2,
};

export const billableStatusRank = (record: StatusFlags): number => RANK[billableStatus(record)];
